var icon = require('vue-svgicon')
icon.register({
  'ks-icon-business': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M92 78h-9.33v9.33H92m0-28h-9.33v9.34H92m9.33 28H64v-9.34h9.33V78H64v-9.33h9.33v-9.34H64V50h37.33m-46.66-9.33h-9.34v-9.34h9.34m0 28h-9.34V50h9.34m0 28h-9.34v-9.33h9.34m0 28h-9.34v-9.34h9.34M36 40.67h-9.33v-9.34H36m0 28h-9.33V50H36m0 28h-9.33v-9.33H36m0 28h-9.33v-9.34H36m28-46.66V22H17.33v84h93.34V40.67z"/>'
  }
})
